const DB_NAME = 'OrdersDB';
const STORE_NAME = 'orders';
const DB_VERSION = 1;

function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: '_id' });
            }
        };

        request.onsuccess = (event) => {
            resolve(event.target.result);
        };

        request.onerror = () => {
            reject('Error opening IndexedDB');
        };
    });
}

export async function saveToIndexedDB(order) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const request = store.put(order);

        request.onsuccess = () => {
            resolve(true);
        };

        request.onerror = () => {
            reject('Error saving order to IndexedDB');
        };
    });
}

export async function loadFromIndexedDB() {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const request = store.getAll();

        request.onsuccess = () => {
            const result = request.result;
            if (Array.isArray(result)) {
                resolve(result);
            } else {
                resolve([]); // fallback to empty array if unexpected data
            }
        };

        request.onerror = () => {
            reject('Error loading orders from IndexedDB');
        };
    });
}
